import { useMutation } from '@apollo/client'
import {
  AddTestSessionMembersFromGroup,
  AddTestSessionMembersFromGroupVariables,
} from '../../types'
import { ADD_TEST_SESSION_MEMBERS_FROM_GROUP } from './operations'

const useAddTestSessionMemberFromGroup = () => {
  const [
    addTestSessionMembersFromGroup,
    { data: addTestSessionMembersFromGroupData, loading: addTestSessionMembersFromGroupLoading },
  ] = useMutation<AddTestSessionMembersFromGroup, AddTestSessionMembersFromGroupVariables>(
    ADD_TEST_SESSION_MEMBERS_FROM_GROUP
  )

  return {
    addTestSessionMembersFromGroup,
    addTestSessionMembersFromGroupData,
    addTestSessionMembersFromGroupLoading,
  }
}

export { useAddTestSessionMemberFromGroup }
